import { datadogRum } from '@datadog/browser-rum';
import { type SegmentAbstraction } from '@repo/segment/Analytics/lib/Segment';
import { v4 as uuid } from 'uuid';
import { ExposureData } from './eventLogging';

interface BucketedEventParams {
  attributes: Record<string, string>;
  anonymousId: string | null;
  deviceId: string;
  deployableVersion?: string;
  exposureData: ExposureData[];
  gitSha: string;
}

export const logABSmartlyBucketingDecision = (
  params: BucketedEventParams,
  analytics: SegmentAbstraction,
) => {
  const segmentInstance = analytics.segmentInstance;

  if (segmentInstance) {
    params.exposureData.forEach(({ experimentKey, variationKey, unitType }) => {
      datadogRum.addFeatureFlagEvaluation(
        // The hyphen is not allowed according to DD documentation
        //  https://docs.datadoghq.com/real_user_monitoring/guide/setup-feature-flag-data-collection/?tab=browser#feature-flag-naming
        experimentKey?.replace('-', '_'),
        variationKey,
      );
      void segmentInstance.track(
        'Absmartly Experiment Bucketing Decision',
        {
          bucketing_id: params.anonymousId,
          bucketing_id_type: 'anonymous_id',
          deployable_name: 'banking-shopping-client',
          deployable_version: params.deployableVersion ?? '1.0.0',
          experiment_key: experimentKey,
          traditional_device_id: params.deviceId,
          user_agent: uuid(),
          user_attributes: {
            ...params.attributes,
          },
          variation_key: variationKey,
          additional_attributes: {
            decision_location: 'client',
          },
        },
        {
          context: {
            app: {
              name: 'banking-shopping-client',
              version: params.gitSha,
            },
          },
        },
      );
    });
  }
};
